export const players = [
  'Ray Allen',
  'Carmelo Anthony',
  'Trevor Ariza',
  'Brent Barry',
  'Nicolas Batum',
  'Bradley Beal',
  'Mike Bibby',
  'Chauncey Billups',
  'Kobe Bryant',
  'Vince Carter',
  'Mike Conley',
  'Jamal Crawford',
  'Stephen Curry',
  'Kevin Durant',
  'Dale Ellis',
  'Michael Finley',
  'Danilo Gallinari',
  'Paul George',
  'Manu Ginobili',
  'Eric Gordon',
  'Danny Green',
  'Tim Hardaway',
  'James Harden',
  'LeBron James',
  'Joe Johnson',
  'Eddie Jones',
  'Jason Kidd',
  'Kyle Korver',
  'Rashard Lewis',
  'Damian Lillard',
  'Kevin Love',
  'Kyle Lowry',
  'Wesley Matthews',
  'Mike Miller',
  'Reggie Miller',
  'Steve Nash',
  'Dirk Nowitzki',
  'Chris Paul',
  'Paul Pierce',
  'JJ Redick',
  'Glen Rice',
  'Jason Richardson',
  'JR Smith',
  'Peja Stojakovic',
  'Jason Terry',
  'Klay Thompson',
  'Nick Van Exel',
  'Antoine Walker',
  'Kemba Walker',
  'Lou Williams',
];
